import { FilterCollectionStore, RemoteObjectStore, SortCollectionStore, StoreBuilder, SyncedRemoteObjectStore } from "@softline/core";
import { Basisartikelstand } from "../types/basisartikelstand";

export const WwsBasisartikelstandStore = new StoreBuilder(SyncedRemoteObjectStore.create<Basisartikelstand>())
  .add(FilterCollectionStore.create<Basisartikelstand>())
  .add(SortCollectionStore.create<Basisartikelstand>())
  .value;